import { render, staticRenderFns } from "./SessionQuiz.Component.vue?vue&type=template&id=2cd3f53b&scoped=true&"
import script from "./SessionQuiz.Component.vue?vue&type=script&lang=ts&"
export * from "./SessionQuiz.Component.vue?vue&type=script&lang=ts&"
import style0 from "./SessionQuiz.Component.vue?vue&type=style&index=0&id=2cd3f53b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd3f53b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VExpandTransition,VRow})
